import { resizedImageSrc, resizedImageSrcset } from '@/utils/resizedImage'

/**
 * Build a CDN-resized URL for blog featured images (Unsplash and Firebase Storage,
 * see `resizedImage.ts`). Anything else is returned as-is.
 */
export function blogImageSrc(url: string | undefined, width: number, height?: number): string | undefined {
    return resizedImageSrc(url, width, height)
}

/**
 * Returns a `srcset` pair (1x, 2x) so retina screens get a sharper image without
 * shipping the 2x to everyone.
 */
export function blogImageSrcset(url: string | undefined, width: number, height?: number): string | undefined {
    return resizedImageSrcset(url, width, height)
}
